module.exports = __webpack_public_path__ + "assets/media/greenCheck.608df217.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/OnboardingInstallNotification/greenCheck.svg
// module id = 2060
// module chunks = 0